import { render, staticRenderFns } from "./EstruturaUsuarioList.vue?vue&type=template&id=3b416dc1"
import script from "./EstruturaUsuarioList.vue?vue&type=script&lang=js"
export * from "./EstruturaUsuarioList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports